import { Navigate } from "react-router-dom";
import { path } from "src/constants/path";

const FundDashboardPage = () => {
  return <Navigate to={`${path.marketWatch}?tab=FundDashboard`} replace />;
};

export default FundDashboardPage;
